import {post, get} from '@/utils/request'

export function getAllLateMoney(data) {
    return post({
        data,
        url:'tbs/fdBill/getAllLateMoney'
    })
}

export function exportLateMoney(data) {
    return get({
        data,
        url:'tbs/fdBill/exportLateMoney',
        responseType: "blob"
    })
}